module.exports = __webpack_public_path__ + "static/media/blu360-cover.ae9100e0.png";